/**
    myFirebaseApp.js

    Accede a la configuración del proyecto FB que usaré en mi aplicación. 
    Las rutas son los nodos a los que accederé a través de los dbXXXXX.
    **********************************************************************************************************************************
 */
import firebase from 'firebase';

/* Obtenemos la configuración de nuestro proyecto en Firebase */
var config = {
    
    // En topevalua@gmail.com (evaluaciones2016)
    apiKey: "AIzaSyCZ1oyLNZg2CKrSO-FkZ0P_MSctBs_0duw",
    authDomain: "topcg-95de7.firebaseapp.com",
    databaseURL: "https://topcg-95de7.firebaseio.com",
    projectId: "topcg-95de7",
    storageBucket: "topcg-95de7.appspot.com",
    messagingSenderId: "399798762836"    
};

/* Inicializamos la configuración */
firebase.initializeApp(config);             // Inicializamos la configuración de FB

export const rutaCasos=         '/casos'              // Obtenemos la ruta del nodo que deseamos acceder
export const rutaUsuarios=      '/usuarios'
export const rutaDeptos=        '/catalogos/deptos'
export const rutaMunis=         '/catalogos/munis'
export const rutaDAS=           '/catalogos/das'
export const rutaDMS=           '/catalogos/dms'
export const rutaTipoS=         '/catalogos/tipoS'
export const rutaSS=            '/catalogos/ss'
export const rutaCargos=        '/catalogos/cargos'
export const rutaResponsables=  '/catalogos/responsables'

export const db=            firebase.database();      // Accedemos a la Base de datos

export const dbCasos   =    db.ref(rutaCasos);        // Direccionamos al nodo correspondiente.
export const dbUsuarios=    db.ref(rutaUsuarios);
export const dbDeptos=      db.ref(rutaDeptos);
export const dbMunis=       db.ref(rutaMunis);
export const dbDAS=         db.ref(rutaDAS);
export const dbDMS=         db.ref(rutaDMS);
export const dbTipoS=       db.ref(rutaTipoS);
export const dbSS=          db.ref(rutaSS);
export const dbCargos=      db.ref(rutaCargos);
export const dbResponsables=db.ref(rutaResponsables);



// WEBPACK FOOTER //
// ./src/store/myFirebaseApp.js